import { FC } from "react";
import AppContainer from "../appContainer";
import StepCard from "../cards/stepCard";
import { cn } from "@/lib";
import { steps } from "@/constants";

const StepsSection: FC = () => {
  return (
    <section className={cn("mb-30 w-full lg:mb-40")}>
      <AppContainer className={cn("h-full")}>
        <div
          className={cn(
            "relative mx-auto flex w-full max-w-[700px] flex-wrap justify-center gap-20 sm:flex-nowrap sm:gap-10 lg:max-w-[900px] lg:gap-20 xl:max-w-[1000px]",
          )}
        >
          {steps.map((step, index) => (
            <StepCard key={step.title} {...step} index={index} />
          ))}
        </div>
      </AppContainer>
    </section>
  );
};

export default StepsSection;
